export default [
    /**
     * Custom validate otp
     */
    {
        path: '/change-payment-method/:tokenRequestId',
        name: 'change.payment.method.otp',
        exact: true,
        component: () => import('@/pages/finance/payment/payment-methods/credit-cards/OTPCreditCardVerification.vue'),
        meta: {
            auth: false,
            title : 'Verify your otp'
        },
    },

    /**
     * Global validate otp
     */
    {
        path: '/validate-otp/:tokenRequestId',
        name: 'validate.otp',
        exact: true,
        component: () => import('@/pages/otp/OTPVerification.vue'),
        meta: {
            auth: false,
            title : 'Verify your otp'
        },
    }
]